import "./limitCharityCardDataPassport.scss";

// @vendor
import React, { Fragment } from "react";
import PropTypes from "prop-types";

// @components
const { OKBoxTitle } = require("commonsComponents/OKBoxTitle");
import OKSelect from "components/commons/OKSelect/OKSelect";
const { OKMessage } = require("commonsComponents/OKMessage");
const { OKLink } = require("commonsComponents/OKLink");

// @utils
import { i18n } from "core/i18n";
const { formatText, FormattedText } = i18n;
const { generateAmounts } = require("utilities/NGOHelper");

const LimitCharityCardDataPassport = ({
    minAmount,
    maxAmount,
    setMinAmountLimit,
    setMaxAmountLimit
}) => {
    const charityAmountsMin = generateAmounts(
        [0, 5, 10, 20, 30, 40, 50],
        "EUR"
    );
    const charityAmountsMax = generateAmounts(
        [99999999, 0, 3, 5, 10, 20, 40, 60, 80, 100],
        "EUR"
    );

    const charityAmountsMinLabel = charityAmountsMin[0].label;
    const charityAmountsMaxLabel = charityAmountsMax[0].label;

    const handleMinAmount = inputData => {
        setMinAmountLimit(inputData.value);
    };

    const handleMaxAmount = inputData => {
        setMaxAmountLimit(inputData.value);
    };

    return (
        <Fragment>
            <OKBoxTitle
                value={
                    <FormattedText value="hireSolidarityCard-solidarityCardLimitsTitle" />
                }
                isNotSeparator={true}
            />
            <div className="row">
                <div className="col-xs-12 col-md-6">
                    <div className="limit-solidarity-card-passport__container">
                        <OKSelect
                            label={
                                <FormattedText value="hireSolidarityCard-minimumAmountMessage" />
                            }
                            searchable={false}
                            placeholder={charityAmountsMinLabel}
                            options={charityAmountsMin.filter(
                                item => item.value <= maxAmount
                            )}
                            onChange={inputData => handleMinAmount(inputData)}
                            value={minAmount}
                        ></OKSelect>
                    </div>
                </div>
                <div className="col-xs-12 col-md-6">
                    <div className="limit-solidarity-card-passport__container">
                        <OKSelect
                            label={
                                <FormattedText value="hireSolidarityCard-maximumAmountMessage" />
                            }
                            searchable={false}
                            placeholder={charityAmountsMaxLabel}
                            options={charityAmountsMax.filter(
                                item => item.value >= minAmount
                            )}
                            onChange={inputData => handleMaxAmount(inputData)}
                            value={maxAmount}
                        ></OKSelect>
                    </div>
                </div>
            </div>
            <OKMessage>
                <FormattedText value="hireSolidarityCard-solidarityCardDisclaimer" />
                &nbsp;
                <OKLink
                    to={formatText("hireSolidarityCard-urlGDPR")}
                    target="_blank"
                    isOKLinkOld
                >
                    <FormattedText
                        value="hireSolidarityCard-solidarityCardDisclaimerLink"
                        className="limit-solidarity-card-passport__link"
                    />
                </OKLink>
            </OKMessage>
        </Fragment>
    );
};

LimitCharityCardDataPassport.propTypes = {
    minAmount: PropTypes.number,
    maxAmount: PropTypes.number,
    setMinAmountLimit: PropTypes.func,
    setMaxAmountLimit: PropTypes.func
};

export default { LimitCharityCardDataPassport };
